import { render, staticRenderFns } from "./skudetailInfor.vue?vue&type=template&id=2eb9a2d1&scoped=true&"
import script from "./skudetailInfor.vue?vue&type=script&lang=js&"
export * from "./skudetailInfor.vue?vue&type=script&lang=js&"
import style0 from "./skudetailInfor.vue?vue&type=style&index=0&id=2eb9a2d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb9a2d1",
  null
  
)

export default component.exports